<template>
<div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>
    <filedialog ref="filedialog"></filedialog>

    <customdialog v-model="dialogSonuc" title="Sonuc">
     

   
    <li v-for="x in excelSonuc">{{x.SatirBilgisi.ExcelDosyaAdi}} - Satir No:{{x.SatirBilgisi.ExcelSatirNo}} - {{ x.Mesaj }}</li>
 

      <br>
    </customdialog>


    <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
            <v-flex xs12 md12 sm12>
                <v-toolbar size="120px" dark color="info">
                    <v-toolbar-title> {{$t('Hotel-List')}} </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-text-field flat="" solo-inverted="" hide-details :label="this.$t('Search')" v-model="searchara" append-icon="search">
                    </v-text-field>

                    <a target="_self" v-bind:href="'#/coper/tanitimlar/Otellistesi/otelislem/id?islem=new'">
                        <v-btn class="white--text" flat>
                            <span class="hidden-sm-and-down"> {{ $t('Add-Joint-Hotel-Price') }} </span>
                            <v-icon right dark>add_box</v-icon>
                        </v-btn>
                    </a>

                    <v-menu bottom left>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>
                  <v-list-tile @click="getListExcel()">
                    <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="ExcelImport()">
                    <v-list-tile-title>Excel Fiyat Aktarımı</v-list-tile-title>
                  </v-list-tile>

                </v-list>
              </v-menu>
                </v-toolbar>
            </v-flex>

            <v-flex pb-3 xs12 sm12 md12 class="pa-2">
                <v-card flat>
                    <v-layout row wrap>
                        <v-flex xs12 sm6 pt-2 md2>
                            <tarihim :etiket="$t('Starting-Date')" v-model="otelListRequest.Donem1" :detaygizle="false" v-bind:defaultvalue="'ok'"></tarihim>
                        </v-flex>
                        <v-flex xs12 sm6 pt-2 md2>
                            <tarihim :etiket="$t('Finishing-Date')" v-model="otelListRequest.Donem2" :detaygizle="false" v-bind:defaultvalue="'ok'"></tarihim>
                        </v-flex>

                        <v-flex pt-2>
                            <v-layout>
                                <div v-if="load1">
                                    <v-btn color="info" @click="getOtelList()" fab small dark>
                                        <v-icon>search</v-icon>
                                    </v-btn>
                                </div>
                                <div v-if="progress">
                                    <v-layout pt-3 align-center>
                                        <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>
                                    </v-layout>
                                </div>
                                <v-badge color="white" :overlap="true">
                                    <template v-slot:badge>
                                        <v-icon v-if="filtrevarmi" large color="green">check_circle_outline</v-icon>
                                    </template>
                                    <v-btn small @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab" @click.native="dialogfiltre=true" color="info" fab dark>
                                        <v-icon>filter_list</v-icon>
                                    </v-btn>
                                    <v-tooltip bottom :activator="el" v-model="tooltip">
                                        <span>{{$t('Add-Search-Filter')}}</span>
                                    </v-tooltip>
                                </v-badge>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-card>
            </v-flex>

            <v-flex class="pa-2">
                <v-data-table :headers="headersotel" :rows-per-page-items="[50]" :items="itemotel" :search="searchara">
                    <template slot="items" slot-scope="props">
                        <tr item>
                            <td class="text-xs-left">{{ props.item.FiyatKodu.isim }}</td>
                            <td class="text-xs-left">{{ props.item.Otel.kod }} - {{ props.item.Otel.isim }} </td>
                            <td class="text-xs-left">{{ props.item.TurOperatoru.kod }}</td>
                            <td class="text-xs-left">{{ props.item.Pansiyon }}</td>
                            <td class="text-xs-left">{{ props.item.Donem1 | dateformat}}</td>
                            <td class="text-xs-left">{{ props.item.Donem2 | dateformat}}</td>
                            <td class="justify-end align-center full-heigth layout px-0">
                                <v-btn @click="git(props.item)" icon small flat>
                                    <v-icon color="info">search</v-icon>
                                </v-btn>
                                <v-btn @click="sil(props.item)" icon small flat>
                                    <v-icon color="warning">delete</v-icon>
                                </v-btn>
                            </td>
                        </tr>
                    </template>
                    <v-alert slot="no-results" :value="true" color="error" icon="warning">
                         {{ $t('No-records-searched-for', { value: searchara}) }}
                    </v-alert>
                </v-data-table>
            </v-flex>

        </v-layout>
    </v-card>

    <v-dialog v-model="dialogfiltre" scrollable persistent max-width="400px">
        <v-card flat color="grey lighten-4">
            <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-layout row wrap>
                    <v-flex xs12 sm6 md12 pa-1>
                        <v-card flat class="white--text">
                            <v-card flat color="grey lighten-5">
                                <v-card-actions>
                                    <v-layout row wrap>
                                        <v-flex md12 xs12 sm12>
                                            <genelarama apiname="SaticiAra" :tip="12" :label="$t('Tour-Operator') +  ':'" v-model="otelListRequest.TurOperatoru"></genelarama>
                                        </v-flex>
                                        <v-flex md12 xs12 sm12>
                                            <geneltipara tip="OtelFiyatKod" label="fiyatKodu :" v-model="otelListRequest.FiyatKodu"></geneltipara>
                                        </v-flex>
                                        <v-flex xs12 sm12 md12>
                                            <genelarama apiname="SaticiAra" :tip="1" v-model="otelListRequest.Otel" label="Otel"></genelarama>
                                        </v-flex>
                                    </v-layout>
                                </v-card-actions>
                            </v-card>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{$t("cancel_button")}}</v-btn>
                <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog persistent max-width="700px" v-model="deleteOtelPrice" @keydown.esc="cancel">
        <v-card>
            <v-card-title style="background-color:#FB9A1E">
                <span class="headline white--text">Otel Fiyat Kayıt Sil</span>
            </v-card-title>
            <v-card-text class="pa-4">
                <v-layout wrap>
                    <v-flex pr-4>
                        <v-alert :value="true" type="warning">
                            Bu kaydı silmek istediğinize emin misiniz?
                        </v-alert>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-actions class="pt-0">
                <v-spacer></v-spacer>
                <v-btn color="warning" text @click.native="agree">{{ $t('Delete') }}</v-btn>
                <v-btn color="grey" text @click.native="cancel" outline>{{$t('Cancel')}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import helpers from '@/components/app/customcomp/helpers'
import tool from '@/components/app/coper/tools'
import tarihim from '@/components/app/customcomp/tarihim'
import genelarama from '@/components/app/coper/comp/genelarama'
import geneltipara from '@/components/app/coper/comp/geneltipara'
import yetkidialog from '@/components/app/customcomp/yetkidialog'
import snackbarcomp from '@/components/app/customcomp/snackbarcomp'
import filedialog from "@/components/app/coper/comp/filedialog.vue";
import customdialog from "@/components/app/coper/comp/customdialog.vue";

export default {
    data() {
        return {
            deleteItem: {
                Id: null
            },
            deleteOtelPrice: false,
            otelListRequest: {
                FiyatKodu: {
                    id: null,
                    kod: null,
                    isim: null,
                    tip: null
                },
                Otel: {
                    id: null,
                    kod: null,
                    isim: null,
                    tip: null,
                    YurtIci_YurtDisi: null
                },
                TurOperatoru: {
                    id: null,
                    kod: null,
                    isim: null,
                    isimAra: null,
                },
                Donem1: null,
                Donem2: null,
            },
            sayfayetki: {
                Screen: false,
                Update: false,
                Save: false,
                Delete: false,
                Status: false,
                Message: null,
                islem: 0
            },
            dialogSonuc:false,
            excelSonuc:{},
            text1:"",
            snackbar:false,
            load1: false,
            progress: false,
            filtrevarmi: false,
            searchara: null,
            el: null,
            tooltip: false,
            dialogfiltre: false,
            itemotel: [],
            headersotel: [{
                    text: "Fiyat Adı",
                    value: "fiyatAdi",
                    width: "20%",
                    align: "left"
                },
                {
                    text: this.$t('Hotel'),
                    value: "otel",
                    width: "20%",
                    align: "left"
                },
                {
                    text: this.$t('Operator-Code'),
                    value: "operatorKod",
                    width: "10%",
                    align: "left"
                },
                {
                    text: this.$t('Hostel'),
                    value: "pansiyon",
                    width: "10%",
                    align: "left"
                },
                {
                    text: this.$t('Period-v2') + " 1",
                    value: "donem1",
                    width: "15%",
                    align: "left"
                },
                {
                    text: this.$t('Period-v2') + " 2",
                    value: "donem2",
                    width: "15%",
                    align: "left"
                },
                {
                    text: this.$t('Process'),
                    width: "5%",
                    align: "right"
                },
            ]
        }
    },
    components: {
        tool,
        tarihim,
        genelarama,
        geneltipara,
        yetkidialog,
        snackbarcomp,
        filedialog,
        customdialog,
    },
    filters: {
        dateformat: function (t) {
            return helpers.dateformat(t);
        },
    },
    mounted() {
        this.sayfayetki = helpers.pageScreenAuth(this.$route.name)
        if (this.sayfayetki.Status == true) {
            this.el = this.$refs.fab.$el;

            this.getOtelList();

        } else {

            this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

                if (sonuc == true) {

                    if (this.prevRoute != null) {
                        var url = '#' + this.prevRoute

                        window.open(url, '_self')
                    } else {
                        var urlMain = '#/'
                        window.open(urlMain, '_self')
                    }
                }

            });

        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.prevRoute = from.path;
        });
    },
    methods: {
        agree() {
            let params = this.deleteItem
            tool.http_post(this, 'OtelFiyatSil', params).then(
                response => {
                    if (response.body.Status == true) {
                        this.deleteOtelPrice = false
                        this.getOtelList()
                    } else {
                        this.text1 = response.body.ErrorList[0]
                        this.snackbar = true
                    }
                },
                response => {
                    this.text1 = 'Hata Oluştu, tekrar deneyiniz'
                    this.snackbar = true
                }
            );
        },
        cancel() {
            this.deleteOtelPrice = false
        },
        git(val) {
            window.localStorage.setItem('otelLoadRequest', JSON.stringify(val))
            var url = "#/coper/tanitimlar/Otellistesi/otelislem/id?islem=get";
            window.open(url, "_blank");
        },
        sil(val) {
            this.deleteItem.Id = Object.assign({}, val)
            this.deleteOtelPrice = true
            var SaticiKodu = {
                SaticiKodu: val.Otel
            }
            delete this.deleteItem.Id.Otel
            this.deleteItem.Id = Object.assign(this.deleteItem.Id, SaticiKodu)
        },
        getOtelList() {
            this.progress = true;
            this.load1 = false;

            let params = {
                FiyatKodu: this.otelListRequest.FiyatKodu,
                Otel: this.otelListRequest.Otel,
                TurOperatoru: this.otelListRequest.TurOperatoru,
                Donem1: this.otelListRequest.Donem1,
                Donem2: this.otelListRequest.Donem2
            }
            tool.http_post(this, 'OtelFiyatList', params).then(
                response => {
                    this.progress = false;
                    this.load1 = true;
                    if (response.body.Status == true) {
                        this.itemotel = response.body.data
                        if(this.dialogfiltre){ this.dialogfiltre = false}
                    } else {
                        this.text1 = response.body.ErrorList[0]
                        this.snackbar = true
                    }
                },
                response => {
                    this.progress = false;
                    this.load1 = true;
                    this.text1 = 'Hata Oluştu, tekrar deneyiniz'
                    this.snackbar = true
                }
            );
        },

        getListExcel() {
   
    
            this.progress = true;
            this.load1 = false;

             let params = {
                FiyatKodu: this.otelListRequest.FiyatKodu,
                Otel: this.otelListRequest.Otel,
                TurOperatoru: this.otelListRequest.TurOperatoru,
                Donem1: this.otelListRequest.Donem1,
                Donem2: this.otelListRequest.Donem2
            }


            tool.api_post_FileDownload(this, "Coper/ExcelOtelFiyatRapor", params).then(
              response => {
                tool.CreateDownloadLink(response, 'OtelFiyatListesi.xlsx');
                this.progress = false;
                this.load1 = true;


              },
              response => {
                this.progress = false;
                    this.load1 = true;
                    this.text1 = 'Hata Oluştu, tekrar deneyiniz'
                    this.snackbar = true
              }
            );
     
    
        },

        ExcelImport() {
            this.$refs.filedialog
          .open("Excel Fiyat Listesi Dosya Seçimi", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
          .then((confirm) => {
            if (confirm !== null) {
                this.DosyaGonder(confirm)
            }
          });
        },

      DosyaGonder(files) {
      if (files.length > 0) {
        this.progress = true;
            this.load1 = false;

        tool
          .api_file_post2(this, "CoperStream/OtelFiyatStream", files, null)
          .then(
            (response) => {
                this.progress = false;
                this.load1 = true;

              if (response.body.Status == true) {
                this.dialogSonuc = true;
                this.excelSonuc = response.body.data;
              } else {
                    this.text1 = response.body.ErrorList[0]
                    this.snackbar = true
              }
            },
            (response) => {
                this.progress = false;
                    this.load1 = true;
                    this.text1 = 'Hata Oluştu, tekrar deneyiniz'
                    this.snackbar = true
            }
          );
      } 
    },


        filtreiptal() {
            this.filtrevarmi = false;
            this.dialogfiltre = false;
        },
        filtrekayit() {
            this.getOtelList()
        }
    }
}
</script>

<style>

</style>
